// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"NewsScroll-module--sectionWrapper--0979c","container":"NewsScroll-module--container--7f4cc","articleWrapper":"NewsScroll-module--articleWrapper--4995f"};